class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.inputKeyword = this.querySelector('.keyword_input');
    this.inputTags = this.querySelector('.inputQueryTags');
    this.tagInputs = this.querySelectorAll('input.advanced_search_checkbox');
    this.categories = this.querySelectorAll('.accordion-item');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener(
        'submit',
        this.onSearchFormSubmit.bind(this)
      );
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
    if (this.tagInputs) {
      this.tagInputs.forEach((input) => {
        input.addEventListener('change', this.tagOnChange.bind(this));
      });
    }
    if (this.categories) {
      this.categories.forEach((details) => {
        details.addEventListener('toggle', function () {
          const icon = details.querySelector('.accordion-icon');
          if (details.open) {
            icon.textContent = '-';
          } else {
            icon.textContent = '+';
          }
        });
      });
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  getTagSelected() {
    var selectedTags = $('.advanced_search_checkbox:checked')
      .map(function () {
        return `tag:${this.value}`;
      })
      .get();
    var uniqTags = [...new Set(selectedTags)];

    var values = uniqTags.join(' OR ');

    return values;
  }

  tagOnChange(event) {
    const inputValue = event.target.value;
    const isChecked = event.target.checked;
    $(`input.advanced_search_checkbox[value="${inputValue}"]`).prop(
      'checked',
      isChecked
    );

    this.inputTags.value = this.getTagSelected();
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.inputTags.value = '';
      this.inputKeyword.value = '';
      this.tagInputs.forEach((input) => {
        input.checked = false;
      });
    }
  }

  getSearchQuery() {
    const inputValue = this.inputKeyword.value.trim();

    let query = inputValue;
    this.input.value = query;

    const inputTagValue = this.getTagSelected();

    if (inputTagValue) {
      query = `${inputValue} ${inputTagValue}`;
      if (query.trim() === '') {
        return this.input.value.trim();
      }

      if (inputValue.length !== 0) {
        this.input.value = `${inputValue} AND ${inputTagValue}`;
      } else {
        this.input.value = inputTagValue.trim();
      }
    }
    return this.input.value.trim();
  }

  onSearchFormSubmit(event) {
    this.inputTags = this.getTagSelected();
    this.input.value = this.getSearchQuery();

    this.input.form.submit();
  }
}

customElements.define('search-form', SearchForm);
